import { type ReactNode, Suspense, lazy, useEffect } from 'react';
import { router } from '@inertiajs/react';
import Navbar from '@/components/public/Navbar';
import Footer from '@/components/public/Footer';
import { useSite } from '@/hooks/useSite';

const ChatWidget = lazy(() => import('@/components/public/chat/ChatWidget'));

export default function PublicLayout({ children }: { children: ReactNode }) {
  const site = useSite();

  useEffect(() => {
    const off = router.on('navigate', () => window.scrollTo({ top: 0, behavior: 'auto' }));
    return () => off();
  }, []);

  return (
    <div className="text-on-surface flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="focus:bg-primary sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-md focus:px-4 focus:py-2 focus:font-semibold focus:text-white focus:shadow-lg"
      >
        Saltar para o conteúdo principal
      </a>
      <Navbar />
      <main id="main-content" className="flex-1">
        {children}
      </main>
      <Footer />
      {site.chatEnabled && (
        <Suspense fallback={null}>
          <ChatWidget />
        </Suspense>
      )}
    </div>
  );
}
